module.exports = __webpack_public_path__ + "img/banner-mobile.bad74158.jpg";